import React from "react";
import { Tooltip } from "@mui/material";
import { REVIEW_TABS } from "../../utils/constants/AdIntelligence";

/** The review page's three tabs, each with its size. */
const ReviewTabs = ({ tab, counts, onSelect }) => {
  return (
    <div className="flex gap-1 overflow-x-auto border-b border-gray-200 px-3">
      {REVIEW_TABS.map((t) => {
        const active = tab === t.key;
        return (
          <Tooltip key={t.key} title={t.hint} placement="top" arrow>
            <button
              type="button"
              aria-pressed={active}
              onClick={() => onSelect(t.key)}
              className={`-mb-px flex shrink-0 items-center gap-1.5 border-b-2 px-3 py-3 text-sm font-medium transition-colors ${
                active
                  ? "border-[#7f7ad5] text-gray-900"
                  : "border-transparent text-gray-500 hover:text-gray-800"
              }`}
            >
              {t.label}
              <span
                className={`rounded-full px-1.5 py-0.5 text-[11px] font-semibold leading-none ${
                  active
                    ? "bg-[#efedfc] text-[#3c3489]"
                    : "bg-gray-100 text-gray-500"
                }`}
              >
                {counts?.[t.key] ?? 0}
              </span>
            </button>
          </Tooltip>
        );
      })}
    </div>
  );
};

export default ReviewTabs;
